import * as React from "react";
import { StyleSheet, View, Image, Text, Pressable, Button } from "react-native";
import PropTypes from "prop-types";
import ArticleGridList from "../components/ArticleGridList.js";
import BottomBannerAd from "./MiscImpl/BottomBannerAd.js";
import { backendUrl } from "../constants/Environment.js";
import * as SecureStore from "expo-secure-store";
import { GlobalSettingsContext } from "../context/GlobalSettingsProvider.js";
import NavbarDesktop from "../components/NavbarDesktop.js";
import { AppDataContext } from "../context/AppDataProvider.js";

export default function ArticleListScreen({
  route,
  setCategory,
  authToken,
  userDetails,
  navigation: { goBack, navigate, setParams },
}) {
  let showCategoryName = route?.params?.showCategoryName;

  const { globalSettings } = React.useContext(GlobalSettingsContext);
  const { categories, colors } = React.useContext(AppDataContext);
  const [isLoadingComplete, setLoadingComplete] = React.useState(false);

  /**
   * For resetting values
   */
  const [articleSupply, setArticleSupply] = React.useState([]);

  const [allArticles, setAllArticles] = React.useState([]);
  const [articleList, setArticleList] = React.useState([]);

  const [isShowBannerAd, setShowBannerAd] = React.useState(false);
  const [bannerAdvertId, setBannerAdvertId] = React.useState("");

  /**
   * Amount of articles to load
   */
  const loadAmount = 6;

  /**
   * Infinite scroll vars
   */
  const [offset, setOffset] = React.useState(1);

  React.useEffect(() => {
    if (showCategoryName) {
      let articleSupplyCopy = JSON.parse(JSON.stringify(articleSupply));
      setAllArticles(
        articleSupplyCopy.filter(
          (a) =>
            a.category &&
            a.category.category_name.toLowerCase() ===
            showCategoryName.toLowerCase()
        )
      );
      setOffset(1);
      let clone = [...articleSupplyCopy];
      clone
        .filter(
          (a) =>
            a.category &&
            a.category.category_name.toLowerCase() ===
            showCategoryName.toLowerCase()
        )
        .slice(0, loadAmount);
      setArticleList(clone);
      setLoadingComplete(true);
    } else {
    }
  }, [showCategoryName]);

  React.useEffect(() => {
    async function loadResourcesAndDataAsync() {
      try {
        /*
         * Load the articles list
         */
        await fetch(`${backendUrl}/articles/`, {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: "Bearer " + authToken,
          },
          method: "GET",
        }).then(async function (response) {
          if (response.status !== 200) {
            console.log("Problem in fetching articles.");
            return;
          }
          response.json().then(function (responseJson) {
            setArticleSupply(JSON.parse(JSON.stringify(responseJson)));
            var allOfThem = JSON.parse(JSON.stringify(responseJson)).sort(
              function (a, b) {
                return new Date(b.createdAt) - new Date(a.createdAt);
              }
            );
            setAllArticles(allOfThem);
            setArticleList(allOfThem.slice(0, loadAmount));
            setLoadingComplete(true);
          });
        });
      } catch (e) {
        console.log(e);
      } finally {
        setLoadingComplete(true);
      }
    }

    async function handleAd() {
      var settingDescription = "Show Banner Ads";
      var settingsShowBannerAds = globalSettings.find(
        (a) => a.description && a.description.includes(settingDescription)
      );
      if (
        settingsShowBannerAds &&
        settingsShowBannerAds.value &&
        settingsShowBannerAds.value.toLowerCase() === "true"
      ) {
        setShowBannerAd(true);

        /**
         * Get the banner ID
         */
        var bannerAdIdSettingDescription = "Banner ID";
        var bannerAdIdSettingResult = globalSettings.find(
          (a) =>
            a.description &&
            a.description.includes(bannerAdIdSettingDescription)
        );
        if (bannerAdIdSettingResult && bannerAdIdSettingResult.value) {
          setBannerAdvertId(bannerAdIdSettingResult.value);
        }
      }

      var isMobile = await SecureStore.isAvailableAsync();
      if (!isMobile) {
        /**
         * On web we can't show ads yet - only mobile gets them!
         */
        setLoadingComplete(false);
        return;
      } else {
        setLoadingComplete(true);

        /**
         * Read the Advert Provider from the back-end (either Admob or FB ads)
         */
        await AdMobInterstitial.setAdUnitID(advertId);
        await AdMobInterstitial.requestAdAsync({ servePersonalizedAds: true });

        /**
         * Apparently only this one works for interstitials...
         */
        AdMobInterstitial.addEventListener("interstitialDidClose", () => {
          goBack();
        });
        await AdMobInterstitial.addEventListener("adClosed", () => {
          goBack();
        });
        await AdMobInterstitial.showAdAsync();
      }
    }

    loadResourcesAndDataAsync();
    handleAd();
  }, [authToken, userDetails, categories]);

  function handleSelectCategory(sel) {
    var result = articleList.find((a) => a.id === parseInt(sel));
    setCategory(result.id);
    navigate("ChooseArticle", { chosenCategory: result.name });
  }

  /**
   * For infinite scroll
   */
  async function loadMoreData() {
    var clone = allArticles.slice(
      offset * loadAmount,
      (offset + 1) * loadAmount - 1
    );
    setOffset((a) => a + 1);
    setArticleList([...new Set(articleList), ...new Set(clone)]);
  }

  if (!isLoadingComplete && articleList.length < 1) {
    return null;
  }

  if (!isLoadingComplete) {
    return null;
  }

  if (!userDetails) {
    /**
     * Don't render until we get some user details in place, supplied by the main entrypoint (App.js).
     */
    return null;
  }

  /**
      * This design type has the vertical list of categories with a few lines of descriptions and widgets.
      */
  return (
    <React.Fragment>
      <View pointerEvents="box-none" style={{ elevation: 2, zIndex: 2, }}>
        <NavbarDesktop
          goBack={goBack}
          navigate={navigate}
          setParams={setParams}
        />
        <View
          style={{
            backgroundColor: colors.background,
            alignItems: "center",
            marginBottom: 0,

          }}
        ></View>
      </View>
      <ArticleGridList
        loadMoreData={loadMoreData}
        items={
          showCategoryName
            ? articleList.filter(
              (a) =>
                a.category &&
                a.category.category_name.toLowerCase() ===
                showCategoryName.toLowerCase()
            )
            : articleList
        }
        selectFunction={handleSelectCategory}
      ></ArticleGridList>

      {isShowBannerAd && bannerAdvertId && (
        <View
          style={{
            backgroundColor: colors.background,
            height: 60,
            borderBottomWidth: 1,
            borderBottomColor: "gray",
            marginTop: -2,
            paddingTop: 14,
          }}
        >
          <BottomBannerAd advertId={bannerAdvertId}></BottomBannerAd>
        </View>
      )}
    </React.Fragment>
  );
}

ArticleListScreen.navigationOptions = {
  header: null,
};

ArticleListScreen.propTypes = {
  text: PropTypes.string,
};
